import { apiGet, apiPost } from './apiClient';

export interface RefundRequestEnriched {
  id: string;
  bookingId: string;
  academyId: string;
  requestedBy: string;
  reason?: string;
  status: 'pending' | 'approved' | 'rejected' | 'refunded';
  processedBy?: string;
  processedAt?: string;
  createdAt: string;
  updatedAt: string;
  booking: { id: string; totalAmount?: number; currency?: string; paymentStatus?: string } | null;
  lessonName: string | null;
  studentName: string | null;
  hasPaymentProcessing?: boolean;
}

export const refundRequestService = {
  async getRefundRequests(academyId: string, status?: 'pending' | 'approved' | 'rejected' | 'refunded') {
    const params: Record<string, string> = { academyId };
    if (status) params.status = status;
    const response = await apiGet<RefundRequestEnriched[]>('/refund-requests', { params });
    return response.data || [];
  },

  async processRefund(refundRequestId: string, academyId: string) {
    await apiPost(`/refund-requests/${refundRequestId}/process`, { academyId });
  },

  async rejectRefund(refundRequestId: string, academyId: string) {
    await apiPost(`/refund-requests/${refundRequestId}/reject`, { academyId });
  },
};
